import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import translate from '../../../../utilities/translator';

const SearchInput = forwardRef((props, ref) => {
  const {
    placeholder,
    ...restProps
  } = props;
  const inputRef = useRef(null);

  useEffect(() => {
    if (window.innerWidth > 768) {
      inputRef.current.focus();
    }
  }, []);

  useImperativeHandle(ref, () => ({
    focusInput: () => {
      inputRef.current.focus();
    },
  }));

  return (
    <div className="search-input">
      <input
        type="text"
        ref={inputRef}
        placeholder={translate(placeholder)}
        {...restProps}
      />
    </div>
  );
})

export default React.memo(SearchInput);
